'use client';

import * as React from 'react';
const usePreviousProps = value => {
  const ref = React.useRef({});
  React.useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
export default usePreviousProps;


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/usePreviousProps/usePreviousProps.js
// module id = 1747
// module chunks = 25